/* Storico PDP sticky Add to cart bar. Shows when the main submit button has scrolled above the viewport.
   Mirrors the main button's state and the current price. No dependencies. */
(function () {
  function init(bar) {
    var id = bar.dataset.section;
    var main = document.getElementById('ProductSubmitButton-' + id);
    var priceBox = document.getElementById('price-' + id);
    if (!main || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('.sto-sticky__btn');
    var now = bar.querySelector('.sto-sticky__now');
    var was = bar.querySelector('.sto-sticky__was');

    function sync() {
      var label = main.querySelector('span');
      var text = (label ? label.textContent : main.textContent).trim();
      if (text) btn.textContent = text;
      var off = main.disabled || main.getAttribute('aria-disabled') === 'true';
      btn.disabled = off;
      if (priceBox) {
        var cur = priceBox.querySelector('.price-item--last, .price-item--sale, .price-item--regular');
        var old = priceBox.querySelector('.price__sale .price-item--regular');
        if (cur) now.textContent = cur.textContent.trim();
        was.textContent = old ? old.textContent.trim() : '';
        was.hidden = !old;
      }
    }

    var show = function (visible) {
      bar.hidden = !visible;
      document.body.classList.toggle('sto-sticky-on', visible);
    };
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      // Show only after the button has scrolled UP out of view (not while it is still below the fold).
      show(!e.isIntersecting && e.boundingClientRect.bottom < 0);
    }).observe(main);

    new MutationObserver(sync).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
    if (priceBox) new MutationObserver(sync).observe(priceBox, { childList: true, subtree: true, characterData: true });
    sync();
  }
  document.querySelectorAll('.sto-sticky').forEach(init);
})();
